export enum InsideIntroduction {
  Facade,
  Underground,
}
